import { MeasuredValue, defaultPtsState } from './types';
import {
  createListenerMiddleware,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { FileParameter, ReadFileData } from '@lmt/shared-types';

let _ptsState = defaultPtsState();

export const ptsSlice = createSlice({
  name: 'pts',
  initialState: () => _ptsState,

  reducers: {
    measuredValuesLoaded(state, action: PayloadAction<MeasuredValue[]>) {
      return {
        ...state,
        measuredValues: action.payload,
      };
    },
    importFinished(state, action: PayloadAction) {
      return {
        ...state,
        measuredValues: [],
        readFile: undefined,
      };
    },
    importRestarted(state, action: PayloadAction) {
      return {
        ...state,
        measuredValues: [],
      };
    },
    importCancelled(state, action: PayloadAction) {
      return {
        ...state,
        measuredValues: [],
        readFile: undefined,
        file: undefined,
        pdfFile: undefined,
      };
    },
    fileRead(state, action: PayloadAction<ReadFileData>) {
      return {
        ...state,
        readFile: action.payload,
      };
    },
    fileLoaded(state, action: PayloadAction<FileParameter>) {
      return {
        ...state,
        file: action.payload
          ? {
              fileName: action.payload.fileName,
              data: action.payload.data,
            }
          : undefined,
      };
    },
    pdfFileLoaded(state, action: PayloadAction<FileParameter | null>) {
      return {
        ...state,
        pdfFile: action.payload
          ? {
              fileName: action.payload.fileName,
              data: action.payload.data,
            }
          : null,
      };
    },
  },
});

export const PtsActions = ptsSlice.actions;
